import React, { useEffect, useState } from "react";
import get from "lodash/get";
import Modal from "../../../parts/modal-new";
import useFormValidation from "../../../hooks/useFormValidation";
import { useTranslation } from "react-i18next";

const ChangeEmailModal = ({ locals }) => {
  const { t } = useTranslation("dashboard");
  const { activeUser } = locals;
  const activeUserEmail = get(activeUser, "email", "");
  const formId = "form-change-email";
  const isValid = useFormValidation(formId);

  return (
    <Modal title={t("changeEmail.title")} className={"change-email-wrapper"}>
      <div className="body">
        <form
          id={formId}
          action="/actions/user/reset-email"
          method="POST"
          data-noreset
        >
          <label>{t("changeEmail.newEmail")}</label>
          <input
            required
            type="text"
            name="email"
            className="text-input"
            defaultValue={activeUserEmail}
            sz="large"
          />

          <label>{t("changeEmail.currentPassword")}</label>
          <input
            required
            type="password"
            name="currentPassword"
            className="text-input"
            sz="large"
          />
        </form>
      </div>
      <footer>
        <a
          role="button"
          data-button-type="secondary"
          data-action="cancel"
          href="/actions/refresh?modal="
        >
          {t("common:cancel")}
        </a>
        <button
          data-button-type="primary"
          form="form-change-email"
          type="submit"
          disabled={!isValid}
        >
          {t("common:save")}
        </button>
      </footer>
    </Modal>
  );
};

export default ChangeEmailModal;
